import { nextTick } from 'vue';
import { createI18n } from 'vue-i18n';
import { Locale } from '@/types';
import { getImportMetaEnvProp } from '@/utils/esmHelpers';

const i18n = createI18n({
  legacy: false,
  locale: getImportMetaEnvProp('VITE_APP_I18N_LOCALE') as Locale,
  fallbackLocale: getImportMetaEnvProp('VITE_APP_I18N_FALLBACK_LOCALE') as Locale,
  messages: {
    en: {},
    fr: {},
  },
  availableLocales: Locale,
});

export async function mergeMessages(messagesName: string) {
  for (const locale of Object.keys(Locale)) {
    const messages = await import(`./locales/${locale}/${messagesName}.${locale}.json`);
    i18n.global.mergeLocaleMessage(locale, messages.default);
  }
  return nextTick();
}

export default i18n;
